<template>
  <el-dialog class="el-dialogs" :append-to-body="true" :title="title" width="600px" :close-on-click-modal="false"
             :visible.sync="visible">
    <el-tabs v-show="pageType == 'edit' || pageType == 'detail'" v-model="activeName">
      <el-tab-pane label="基本信息" name="first"></el-tab-pane>
      <el-tab-pane label="资源数值列表" name="second"></el-tab-pane>
    </el-tabs>
    <el-form v-show="activeName == 'first'" size="small" ref="searchForm" :model="searchForm" :rules="rules"
             @keyup.enter.native="doSubmit()" @submit.native.prevent :disabled="pageType == 'detail'"
             label-width="110px">
      <el-form-item label="名称：" prop="semanticName">
        <el-input v-model.trim="searchForm.semanticName" maxlength="20"
                  placeholder="请输入名称(限20字)"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="描述：" prop="semanticDescription">
        <el-input
            type="textarea"
            :rows="5" maxlength="500" resize="none"
            placeholder="请输入语义库数据描述信息(限500字)"
            v-model.trim="searchForm.semanticDescription">
        </el-input>
      </el-form-item>
    </el-form>
    <div v-if="activeName == 'second'">
      <div class="flex_b_c" style="margin-bottom: 10px">
        <el-button v-if="pageType != 'detail'" size="small" type="primary" @click="addFigure()">新增</el-button>
        <div></div>
        <el-input v-model.trim="valueSearch.keyword" maxlength="20" size="small" style="width: 200px"
                  placeholder="请输入数值搜索(限20字)" suffix-icon="el-icon-search" @input="refreshList(1)"
                  clearable></el-input>
      </div>
      <el-table
          :data="valueDataList"
          v-loading="loading"
          size="small" height="200px"
          class="table" ref="multipleTable" row-key='id' border>
        <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
        <el-table-column prop="dataName" label="数值" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dataSort" label="排序" show-overflow-tooltip></el-table-column>
        <el-table-column
            fixed="right" min-width="100px"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addFigure(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="deleteData(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="valueSearch.current" :limit.sync="valueSearch.size"
                  @pagination="refreshList"/>
    </div>
    <div slot="footer">
      <el-button v-if="pageType != 'detail'" size="small" type="primary" @click="doSubmit()" v-noMoreClick>保存
      </el-button>
      <el-button v-if="pageType != 'detail'" size="small" @click="visible = false">取消</el-button>
    </div>


    <el-dialog class="el-dialogs" :append-to-body="true" :title="title2" width="400px" :close-on-click-modal="false"
               :visible.sync="visible2">
      <el-form size="small" ref="addForm" :model="addForm" :rules="addFormRules"
               @keyup.enter.native="doSubmitAdd()" @submit.native.prevent
               label-width="110px">
        <el-form-item label="数值：" prop="dataName">
          <el-input v-model.trim="addForm.dataName" maxlength="20"
                    placeholder="请输入数值(限20字)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="dataSort">
          <el-input-number v-model="addForm.dataSort" :min="1" :max="maxSort"
                           label="请输入数值"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" type="primary" @click="doSubmitAdd()" v-noMoreClick>确定</el-button>
        <el-button size="small" @click="visible2 = false">取消</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>

export default {
  name: "semanticAdd",
  data() {
    return {
      title: '新增语义库数据',
      visible: false,
      searchForm: {
        id: '',
        parentId: '',
        semanticName: '',
        semanticDescription: '',
      },
      rules: {
        semanticName: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
      },
      selectData: {},
      pageType: '',
      activeName: 'first',

      valueSearch: {
        semanticId: '',
        keyword: '',
        current: 1,
        size: 20,
      },
      total: 0,
      valueDataList: [],
      loading: false,

      title2: '新增数值',
      visible2: false,
      addForm: {
        id: '',
        dataName: '',
        dataSort: 1,
        semanticId: '',
      },
      maxSort: '',
      addFormRules: {
        dataName: [
          {required: true, message: '请输入数值', trigger: 'blur'}
        ],
        dataSort: [
          {required: true, message: '请输入排序', trigger: 'blur'}
        ],
      },
    }
  },

  methods: {
    init(type, row) {
      this.visible = true
      this.searchForm.id = ''
      this.$nextTick(() => {
        this.$refs.searchForm.resetFields();
      })
      this.activeName = 'first'
      this.valueSearch.keyword = ''
      this.valueSearch.semanticId = ''
      this.valueSearch.current = 1
      this.valueSearch.size = 20
      this.selectData = row
      this.pageType = type
      this.title = '新增语义库数据'
      if (type == 1) {
        this.searchForm.parentId = row.parentId
      } else if (type == 2) {
        this.searchForm.parentId = row.id
      } else {
        this.title = row.semanticName
        this.getDetail()
        this.valueSearch.semanticId = row.id
        this.addForm.semanticId = row.id
        this.refreshList(1)
      }
    },

    getDetail() {
      this.$axios(this.api.academic.semanticcorpusGetById + this.selectData.id, {}, 'get').then(data => {
        if (data && data.status) {
          Object.keys(this.searchForm).forEach(key => {
            this.searchForm[key] = data.data[key]
          })
        }
      })
      this.$axios(this.api.user.configKey + 'publish_sequence').then(data => {
        if (data && data.status) {
          this.maxSort = data.data
        }
      })
    },

    refreshList(currtSet) {
      if (currtSet == 1) {
        this.valueSearch.current = 1
      }
      this.loading = true
      this.$axios(this.api.academic.semanticcorpusdataList, this.valueSearch, 'get').then(data => {
        if (data && data.status) {
          this.loading = false
          this.valueDataList = data.data.records
          this.total = parseInt(data.data.total)
          if (this.valueDataList.length == 0 && this.valueSearch.current > 1) {
            this.valueSearch.current--
            this.refreshList()
          }
        }
      })
    },

    addFigure(row) {
      this.visible2 = true
      this.title2 = '新增数值'
      this.addForm.id = ''
      this.$nextTick(() => {
        this.$refs.addForm.resetFields();
      })
      if (row) {
        this.title2 = '编辑数值'
        this.getFigureDetail(row.id)
      }
    },

    getFigureDetail(id) {
      this.$axios(this.api.academic.semanticcorpusdataGetById + id, {}, 'get').then(data => {
        if (data && data.status) {
          Object.keys(this.addForm).forEach(key => {
            this.addForm[key] = data.data[key]
          })
        }
      })
    },

    deleteData(row) {
      this.$confirm(`您是否确认删除数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.academic.semanticcorpusdataRemoveById + row.id, {}, 'delete').then(data => {
          if (data && data.status) {
            this.$message.success('删除成功')
            this.refreshList()
          }
        })
      })
    },

    doSubmitAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (!this.addForm.id) {
            this.$axios(this.api.academic.semanticcorpusdataSave, this.addForm, 'post').then(data => {
              if (data && data.status) {
                this.$message.success('保存成功')
                this.visible2 = false
                this.refreshList()
              } else {
                this.$message.error(data.msg)
              }
            })
          } else {
            this.$axios(this.api.academic.semanticcorpusdataUpdateById, this.addForm, 'put').then(data => {
              if (data && data.status) {
                this.$message.success('修改成功')
                this.visible2 = false
                this.refreshList()
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        }
      })
    },


    //提交
    doSubmit() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          if (this.searchForm.id) {
            this.$axios(this.api.academic.semanticcorpusUpdateById, this.searchForm, 'put').then(data => {
              if (data && data.status) {
                this.$message.success('修改成功')
                this.visible = false
                this.$emit('refresh')
              } else {
                this.$message.error(data.msg)
              }
            })
          } else {
            this.$axios(this.api.academic.semanticcorpusSave, this.searchForm, 'post').then(data => {
              if (data && data.status) {
                this.$message.success('保存成功')
                this.visible = false
                this.$emit('refresh')
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        }
      });
    },
  },
}
</script>

<style scoped>

</style>